import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@material-ui/core";
import BarChartIcon from "@material-ui/icons/BarChart";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import HistoryIcon from "@material-ui/icons/History";
import ListAltIcon from "@material-ui/icons/ListAlt";

const cardStyle = { borderRadius: 12, minHeight: 64 };

const TarjetasTendencias = ({ metricas, tieneDatos }) => {
  const { promedioTotal, mejorCompetencia, ultimoIntento, totalIntentos } = metricas || {};

  const items = [
    {
      title: "Promedio total",
      value: tieneDatos && promedioTotal != null ? String(promedioTotal) : "—",
      icon: <BarChartIcon color="primary" fontSize="medium" />,
    },
    {
      title: "Mejor competencia",
      value: tieneDatos && mejorCompetencia ? mejorCompetencia.label : "—",
      icon: <EmojiEventsIcon style={{ color: "#22c55e" }} fontSize="medium" />,
    },
    {
      title: "Último intento",
      value: tieneDatos && ultimoIntento != null ? String(ultimoIntento) : "—",
      icon: <HistoryIcon style={{ color: "#f59e0b" }} fontSize="medium" />,
    },
    {
      title: "Total intentos",
      value: tieneDatos ? String(totalIntentos || 0) : "—",
      icon: <ListAltIcon style={{ color: "#7c3aed" }} fontSize="medium" />,
    },
  ];

  return (
    <Grid container spacing={1}>
      {items.map((it) => (
        <Grid item xs={6} sm={3} key={it.title}>
          <Card elevation={2} style={cardStyle}>
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                padding: "8px 10px",
              }}
            >
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.25}>
                <Typography variant="body2" color="textSecondary" style={{ fontWeight: 700, fontSize: "0.875rem" }}>
                  {it.title}
                </Typography>
                {it.icon}
              </Box>
              <Typography variant="body1" style={{ marginTop: 2, fontWeight: 700 }}>
                {it.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TarjetasTendencias;
